import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Dropdown, DropdownItem } from '@base-app';
import { PATHS } from '@constants/routes';
import { useAuth } from '@modules/auth/hooks';
import { useAuthStore } from '@modules/auth/store';
import { HEADER_DROPDOWN_OPTIONS } from '@modules/core/constants';

import NavHeader from '../NavHeader/NavHeader';

const HeaderDropdownNav: FC = () => {
  const { logout: authStoreLogout, user: currentUser, updateIsLoggingOut } = useAuthStore();
  const { authService, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const currentUserName: string =
    currentUser?.profile !== undefined ? `${currentUser.profile.firstName} ${currentUser.profile.lastName}` : '';
  const logout = async (): Promise<void> => {
    updateIsLoggingOut(true);
    await authService
      .signOut()
      .then(() => {
        authStoreLogout();
      })
      .catch(() => {
        updateIsLoggingOut(false);
      });
  };

  const { TEAM_MANAGEMENT, MY_ACCOUNT, LOG_OUT } = HEADER_DROPDOWN_OPTIONS;

  const dropdownOptions = [
    {
      id: MY_ACCOUNT,
      label: t('my_account'),
    },
    {
      id: TEAM_MANAGEMENT,
      label: t('team_management'),
    },
    {
      id: LOG_OUT,
      label: t('logout'),
    },
  ];

  const handleSelect = async (option: DropdownItem): Promise<void> => {
    if (option.id === MY_ACCOUNT) {
      navigate(`/${PATHS.MY_ACCOUNT}`, { replace: true });
    }

    if (option.id === TEAM_MANAGEMENT) {
      navigate(`/${PATHS.TEAMS}`, { replace: true });
    }

    if (option.id === LOG_OUT) {
      await logout();
    }
  };

  return (
    <>
      <NavHeader isAuthenticated={isAuthenticated === true} />
      {isAuthenticated === true && currentUser !== null && (
        <Dropdown id="header-dropdown-nav" title={currentUserName} items={dropdownOptions} onSelect={handleSelect} />
      )}
    </>
  );
};

export default HeaderDropdownNav;
